mainApp.directive('checkboxList', function() {
    return {
        templateUrl: '/public/directives/checkboxlist.html',
        scope: {
            list: "=",
            model: "=",
            label: "@"
        },
        controller: function($scope) {
            $scope.items = null;
            $scope.getItems = function(){
                if($scope.items == null && $scope.list != null){
                    $scope.items = $scope.list.split(",");
                }
                return $scope.items;
            };
            $scope.isChecked = function(item){
                return $scope.items.indexOf(item) >= 0;
            };
            $scope.check = function(item){
                toggleSelection($scope.items,item);
                $scope.model = $scope.items.join(",");
            }
        }
    };
});
